<template>
  <div class="container">
    <headerview></headerview>
    <div class="banner">
      <img src="../assets/images/art_banner.jpg" alt="">
    </div>
<!--    <nav>
      <div class="nav">
        <div class="subnav" @click="tonav(index)" :class="{'this': here[index]}"  v-for="(item, index) in navlist">
          <span>{{item}}</span>
        </div>
      </div>
    </nav> -->
    <div class="article">
      <div class="article-con">
        <!-- <h1>{{title}}</h1>
        <div class="article-msg">
          <p>文章来源:{{fromto}}</p>
          <p>发布时间:{{time}}</p>
          <p>阅读:{{num}}次</p>
        </div>
        <div class="main" v-html="content"></div>
        <div class="change">
          <div @click="toPrev" class="prev-article">
            <p>上一条</p>
            <span>{{prev.title}}</span>
          </div>
          <div class="to-path" @click="tonews">
            <img src="../assets/images/backbtn.png" alt="">
          </div>
          <div @click="toNext" class="next-article">
            <p>下一条</p>
            <span>{{next.title}}</span>
          </div>
        </div> -->
        <div class="art-top">
          <div class="art-left">
            <h1>{{title}}</h1>
            <div class="article-msg">
              <span>{{time}}</span>
              <span>来源: &nbsp;{{fromto}}</span>
              <span>浏览数: &nbsp;{{num}}</span>
            </div>
          </div>
          <div class="art-right">
            <div class="good" @click="good">
              <span>{{like}}</span>
            </div>
            <router-link :to="toPrev()">
              <div class="prev-art" :class="{'prevshow': prevshow}"><</div>
            </router-link>
            <div class="to-path" @click="tonews"></div>
            <router-link :to="toNext()">
              <div class="next-art" :class="{'nextshow': nextshow}">></div>
            </router-link>
          </div>
        </div>
        <div class="art-content">
          <div class="main" v-html="content"></div>
          <div class="change">
            <router-link :to="toPrev()">
              <div class="prev-article">
                <span>上一篇:</span>
                <span>{{prev.title}}</span>
              </div>
            </router-link>
            <router-link :to="toNext()">
              <div class="next-article">
                <span>下一篇:</span>
                <span>{{next.title}}</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <footerview></footerview>
  </div>
</template>

<script>
  import headerview from './public/header.vue'
  import footerview from './public/footer.vue'
  import 'wowjs/css/libs/animate.css'
  import { content, prevNext, get_num, get_good } from '../api/index.js'
  import { option } from '../public/public.js'
  export default {
    name: 'async',
    metaInfo(){
      return {
        title: this.title,
        meta: [{
          name:'viewport', content:'width=device-width, user-scalable=yes, initial-scale=1.0, maximum-scale=3.0, minimum-scale=1.0',
        },{                 // set meta
          name: 'keyWords',
          content: '中天亿信，网站建设，网站群建设，分销平台开发，网络营销推广，政务大数据，电商大数据，智慧城市，智慧政务，智慧教育，全媒体平台，云计算，企业邮箱，域名注册'
        },{                 // set meta
          name: 'description',
          content: '中天亿信是中国领先的互联网+大数据服务商，新三板上市企业、国家高新技术企业、软件企业、增值电信业务运营商，为您提供互联网平台建设、云计算、大数据以及智慧城市解决方案等服务。'
        }],
      }
    },
    // metaInfo: {
    //   meta: [{ name:'viewport', content:'width=device-width, user-scalable=yes, initial-scale=1.0, maximum-scale=3.0, minimum-scale=1.0'}],
    //   meta: [{                 // set meta
    //       name: 'keyWords',
    //       content: '中天亿信，网站建设，网站群建设，分销平台开发，网络营销推广，政务大数据，电商大数据，智慧城市，智慧政务，智慧教育，全媒体平台，云计算，企业邮箱，域名注册'
    //   }],
    //   meta: [{                 // set meta
    //       name: 'description',
    //       content: '中天亿信是中国领先的互联网+大数据服务商，新三板上市企业、国家高新技术企业、软件企业、增值电信业务运营商，为您提供互联网平台建设、云计算、大数据以及智慧城市解决方案等服务。'
    //   }]
    // },
    components: {
      headerview,
      footerview
    },
    data(){
      return {
        path: "",
        parent_ch: 0,
        like: 0,
        classs: [false, false],
        navlist: ["行业新闻","公司动态","公示公告"],
        title: "",
        fromto: "",
        time: "",
        num: "",
        content: "",
        prev: {},
        next: {},
        id: 0,
        ch: 0,
        here: [false, false, false],
        prevshow: false,
        nextshow: false,
      }
    },
    watch: {
      // $route: {
      //   handler(newName, oldName) {
      //     this.$router.go(0)
      //   },
      //   deep: true,
      // },
    },
    mounted() {
        // 在项目加载完成之后初始化wow
      new this.$wow.WOW({
        live: false
      }).init()
    },
    created() {
      // localStorage.getItem("goods")
      if(this.$route.params.ch == 25){
        for(let i = 0;i<2;i++){
          this.$set(this.here, i, false)
        }
        this.$set(this.here, 0, true)
      }else if(this.$route.params.ch == 24){
        for(let i = 0;i<2;i++){
          this.$set(this.here, i, false)
        }
        this.$set(this.here, 1, true)
      }else if(this.$route.params.ch == 26){
        for(let i = 0;i<2;i++){
          this.$set(this.here, i, false)
        }
        this.$set(this.here, 2, true)
      }



      this.id = parseInt(this.$route.params.id);
      this.ch = this.$route.params.ch;
      content({
        apikey: 123456,
        id: this.id
      }).then(res => {
        this.content = res.data.content
        this.title = res.data.title
        this.num = res.data.views
        this.time = option.complete(res.data.createtime * 1000)
        this.fromto = res.data.origins
        this.like = res.data.likes
        this.parent_ch = res.data.channel.parent_id
        console.log(res.data)
        console.log(1)
      }).catch(err => {
        console.log(err)
      })
      prevNext({
        apikey: 123456,
        channel: this.ch,
        id: this.id,
        type: "prev"
      }).then(res => {
        if(res.data != null){
          this.prev = res.data
        }else{
          this.prev = {title: "没有了"}
          this.prevshow = true
        }
      }).catch(err => {

      })
      prevNext({
        apikey: 123456,
        channel: this.ch,
        id: this.id,
        type: "next"
      }).then(res => {
        if(res.data != null){
          this.next = res.data
        }else{
          this.next = {title: "没有了"}
          this.nextshow = true
        }
      }).catch(err => {

      })
      get_num({
        apikey: 123456,
        id: this.id
      }).then(res => {

      }).catch(err => {

      })
    },
    methods: {
      good(){
        let goods = 'isgood' + this.id
        if(localStorage.getItem(goods)){
          alert('你已经点赞过')
        }else{
          this.like ++
          get_good({
            apikey: 123456,
            id: this.id,
            type: 'like'
          }).then(res => {
            localStorage.setItem(goods, "1")

          }).catch(err => {

          })
        }
      },

      tonews(){
        if(this.ch == 24){
          this.$router.push({
            name: 'content',
            params: {
              ch: '24',
              page: '1.html'
            }
          })
        }else if(this.ch == 25){
          this.$router.push({
            name: 'content',
            params: {
              ch: '25',
              page: '1.html'
            }
          })
        }else if(this.ch == 26){
          this.$router.push({
            name: 'content',
            params: {
              ch: '26',
              page: '1.html'
            }
          })
        }else if(this.parent_ch == 36){
          this.$router.push({
            path: '/about.html'
          })
        }else if(this.parent_ch == 2){
          this.$router.push({
            path: '/support.html'
          })
        }else if(this.ch == 31){
          this.$router.push({
            path: '/aplication.html'
          })
        }else if(this.ch == 47){
          this.$router.push({
            path: '/cp.html'
          })
        }

      },
      toPrev(){
        if(this.prev.title != "没有了"){
          return{
            name: 'article',
            params: {
              id: this.prev.id + '.html',
              ch: this.prev.channel_id
            }
          }
        }else{
          return{
            name: 'article',
            params: {
              id: this.$route.params.id + '.html',
              ch: this.$route.params.ch
            }
          }
        }
      },
      toNext(){
        if(this.next.title != "没有了"){
          return{
            name: 'article',
            params: {
              id: this.next.id + '.html',
              ch: this.next.channel_id
            }
          }
        }else{
          return{
            name: 'article',
            params: {
              id: this.$route.params.id + '.html',
              ch: this.$route.params.ch
            }
          }
        }
      },
    }
  }
</script>

<style scoped>
.container{overflow-x: hidden;}
.bg{position: fixed; width: 100%; height: 100%; background: url(../assets/images/join_02.jpg) center center; background-size: cover; z-index: -1;}
.banner{width: 100%; position: relative; font-size: 0;}


/* .this{background: #1f4071;}
nav{width: 100%; height: 81px; background-color: #1a345a;}
.nav{width: 90%; max-width: 1600px; margin: auto; display: flex;}
.subnav{position: relative; width: 33.33%; cursor: pointer; text-align: center; transition: all .5s;}
.subnav span{position: relative; color: #cbd8e7; line-height: 80px; font-size: 18px;}
.subnav span::before{content: ""; position: absolute; display: block; right: -70px; width: 30px; height: 1px; top: 50%; background: rgba(255, 255, 255, 0.3); opacity: 0; transition: all .4s;}
.subnav span::after{content: ""; position: absolute; display: block; left: -70px; width: 30px; height: 1px; top: 50%; background: rgba(255, 255, 255, 0.3); opacity: 0; transition: all .4s;}
.subnav:hover{background: #1f4071;}
.th{background: #1f4071 !important;}
.subnav:hover span::before{right: -40px; opacity: 1;}
.subnav:hover span::after{left: -40px; opacity: 1;}
.subnav::after{content: ""; position: absolute; width: 1px; height: 100%; left: 0; top: 0; background: #fff; opacity: .2;}
.subnav:last-child::before{content: ""; position: absolute; width: 1px; height: 100%; right: 0; top: 0; background: #fff; opacity: .2;} */
.banner img{width: 100%;}

.article{width: 100%; padding: 50px 0 50px 0; background: #eaeaea;}
.article-con{width: 90%; max-width: 1300px; margin: 0 auto;}
.art-top{display: flex; justify-content: space-between; padding-bottom: 30px;}
.art-top h1{font-size: 24px; font-weight: normal; color: #333333;}
.article-msg{font-size: 14; color: #a3a3a3; padding-top: 20px;}
.article-msg span{padding-right: 20px;}
.art-left{max-width: 690px;}

.art-right{text-align: right;}
.art-right div{display: inline-block; vertical-align: top;}
.art-right p{font-size: 14px; padding-top: 6px; color: #a2a2a2;}
.good{position: relative; cursor: pointer; line-height: 45px; margin-left: 4px; max-width: 43px; max-width: 43px; overflow: hidden; height: 43px; border-radius: 22px; border: 2px solid #d3d3d3; transition: .5s all ease;}
.good span{position: relative; margin-left: 43px; padding-right: 10px; font-size: 18px; color: #d4d4d4;}
.good::after{content: ""; display: block; width: 43px; height: 100%; background: url(../assets/images/good.png) center center no-repeat; background-size: 60% 60%; left: 0; top: 0; position: absolute;}
.good:hover::after{background: url(../assets/images/good_hover.png) center center no-repeat; background-size: 60% 60%;}
.to-path{position: relative; cursor: pointer; margin-left: 4px; width: 43px; height: 43px; border-radius: 50%; border: 2px solid #d3d3d3; transition: .5s all;}
.to-path::after{content: ""; display: block; width: 100%; height: 100%; background: url(../assets/images/home.png) center center no-repeat; left: 0; top: 0; position: absolute;}
.to-path:hover::after{background: url(../assets/images/home_hover.png) center center no-repeat;}
.good:hover, .to-path:hover{background: #8c8c8c; border: 2px solid #8c8c8c;}
.good:hover{width: auto; max-width: 203px;}
.prev-art:hover, .next-art:hover{background-color: #8c8c8c; border: 2px solid #8c8c8c; color: #eaeaea;}
.nextshow, .prevshow{display: none;}

.prev-art, .next-art{width: 43px; height: 43px; cursor: pointer; margin-left: 4px; font-family: '宋体' !important; text-align: center; font-size: 26px; color: #d4d4d4; font-weight: bold; line-height: 45px; border-radius: 50%; border: 2px solid #d3d3d3; transition: .5s all;}

.art-content{background-color: #fff;}
.main{width: 100%; padding: 30px 60px 30px 60px; box-sizing: border-box; border-bottom: 1px solid #eaeaea;}
.main >>> *{color: #3a3a3a !important; font-family: '微软雅黑' !important;}
.main >>> p{padding-top: 20px; line-height: 34px !important;}
.main >>> img{max-width: 100%; display: block; margin: 0 auto;}

.change{ padding: 30px 60px 30px 60px; box-sizing: border-box; display: flex; justify-content: space-between;}
.change a{display: block; width: 60%;}
.change a:nth-child(2){display: block; width: 40%;}
.prev-article,.next-article{width: auto; max-width: 80%; color: #000000; cursor: pointer; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;}
/* .main >>> p{padding-top: 20px; color: #e8e8e8 !important;}
.main >>> p *{color: #e8e8e8 !important; font-size: 16px !important;}
.main >>> img{margin: 0 auto; display: block; max-width: 100%;}
.article-msg{width: 100%; padding: 40px 0 20px 0; border-bottom: 1px dashed rgba(255, 255, 255, .4); display: flex; justify-content: space-between;}
.article-msg p{flex: 1;}
.article-msg p:nth-child(2){text-align: center;}
.article-msg p:nth-child(3){text-align: right;}
.article-con h1{font-size: 30px; text-align: center;}
.main{padding: 10px 0 30px 0; line-height: 30px;}
.change{position: relative; width: 100%; line-height: 40px; color: #cecece; box-sizing: border-box; background: #0069b5; border-radius: 20px; padding: 16px 30px 16px 30px; display: flex; justify-content: space-between;}
.change .next-article{text-align: right; transition: all .5s; cursor: pointer;}
.change .next-article:hover{color: #fff;}
.change .prev-article{text-align: left; transition: all .5s;}
.change .prev-article:hover{color: #fff; cursor: pointer;} */

@media screen and (max-width: 1280px) {
  /* .word h1{font-size: 30px;}
  .word h2{font-size: 30px;}
  .scroll-down{width: 80px; height: 100px;}
  .scroll-down::after{width: 5px; height: 5px;}
  .prev, .next{width: 55px; height: 55px; line-height: 55px;} */
}

@media screen and (min-width: 1024px) and (max-width: 1440px){
  /* .subnav span{font-size: 14px; line-height: 60px;}
  nav{height: 60px;}
  .subnav span::before, .subnav span::after{width: 20px;}
  .subnav:hover span::before{right: -30px;}
  .subnav:hover span::after{left: -30px;} */
}

@media screen and (max-width: 1024px) {
  .art-right p{display: none;}
  .art-right div{width: 34px; height: 34px; line-height: 34px;}
  .good::after{width: 34px;}
  /* .nav{width: 100%;}
  .subnav{width: 100%;}
  .nav{flex-wrap: wrap;}
  nav{height: auto;}
  .subnav span{font-size: 12px; line-height: 40px;}
  .subnav:nth-child(n+2)::before{content: ""; position: absolute; width: 1px; height: 100%; right: 0; top: 0; background: #fff; opacity: .2;}
  .subnav:nth-child(-n+2){border-bottom: 1px solid rgba(255, 255, 255, .2);} */
}



@media screen and (max-width: 768px) {
  .art-right{width: 100%; padding-top: 10px;}
  .art-top{flex-wrap: wrap;}
  .article-msg{padding-top: 10px;}
  .article-msg span{font-size: 12px; padding-right: 10px;}
  .main{padding: 10px; padding-top: 0;}
  .art-top{padding-bottom: 10px;}
  .main >>> *{font-size: 14px !important;}
  .main >>> p{padding-top: 10px;}
  .main >>> img{width: 100%; max-width: 100%;}
  .change{padding: 10px;}
  .change{flex-wrap: wrap; font-size: 14px;}
  .article{padding-top: 20px; padding-bottom: 20px;}
  .prev-article, .next-article{width: 100%; max-width: 100%; line-height: 30px;}
  /* .banner-img{display: none;}
  .banner-img1{display: block;}
  .word h1, .word h2{font-size: 20px !important;}
  .next,.prev{display: none;}
  .article-msg p:nth-child(2){flex: 1.4;}
  .article-msg p:nth-child(3){flex: .6;}
  .article-msg{font-size: 12px;}
  .change{flex-wrap: wrap;}
  .prev-article{width: 100%; line-height: 20px;}
  .to-path{position: relative; width: 60px; height: 60px; overflow: hidden;}
  .to-path img{position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);}
  .next-article{width: 100%; line-height: 20px; text-align: left !important;} */
}
</style>



// WEBPACK FOOTER //
// src/components/article.vue